import { IExtendedRootScopeService } from "./../../shared/ng-extensions/models";
import { IModalScope } from "angular-ui-bootstrap";
import { IAssignee } from "../models";
import { IUIError, UIErrorHandlingService } from "@gtmhub/error-handling";

import { INgRedux } from "@gtmhub/state-management";
import { IAssigneesStoreState } from "../redux/assignee-reducer";
import { AssigneeActions } from "../redux/assignee-actions";

const bindStateToScope = (state: IAssigneesStoreState) => {
  const { map: assignees, isFetched: assigneesFetched, error: assigneesError } = state.assignees;

  return {
    assignees,
    assigneesFetched,
    assigneesError,
  };
};

interface ISelectAssigneesModalCtrl extends IModalScope, IExtendedRootScopeService {
  indicators: {
    loadingAssignees?: boolean;
  };
  assignees: IAssignee[];
  assigneesFetched: boolean;
  assigneesError: IUIError;
  selectedAssignees: string[];
  countSelected: number;
  toggleItemInSelection(selectedItem: string): void;
  finish(): void;
  close(): void;
}

export class SelectAssigneesModalCtrl {
  public static $inject = ["$ngRedux", "AssigneeActions", "$scope", "targetGroup", "selectedEmployeesOrTeams", "UIErrorHandlingService"];

  constructor(
    $ngRedux: INgRedux,
    assigneeActions: AssigneeActions,
    private $scope: ISelectAssigneesModalCtrl,
    private targetGroup: string,
    private selectedEmployeesOrTeams: string[],
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    this.$scope.selectedAssignees = angular.copy(this.selectedEmployeesOrTeams);
    this.$scope.countSelected = this.selectedEmployeesOrTeams.length;
    this.$scope.toggleItemInSelection = this.toggleItemInSelection;
    this.$scope.finish = this.finish;
    this.$scope.close = this.close;
    this.$scope.indicators = {};

    const unsubscribe = $ngRedux.connect(bindStateToScope)(this.$scope);
    this.$scope.$on("$destroy", unsubscribe);
    $ngRedux.dispatch(assigneeActions.getAssignees());

    this.loadAssignees();
  }

  private loadAssignees = (): void => {
    this.$scope.indicators.loadingAssignees = true;
    // Needs pagination
    this.$scope
      .watchUntilAndRejectOnError(
        () => this.$scope.assigneesFetched,
        () => this.$scope.assigneesError
      )
      .then(
        () => {
          this.$scope.assignees = Object.values(this.$scope.assignees);
          this.$scope.indicators.loadingAssignees = false;

          if (this.targetGroup !== "both") {
            this.$scope.assignees = this.$scope.assignees.filter((assignee) => assignee.type === this.targetGroup);
          }
        },
        () => this.uiErrorHandlingService.handleModal(this.$scope.assigneesError)
      );
  };

  private toggleItemInSelection = (id: string): void => {
    if (this.$scope.selectedAssignees.indexOf(id) === -1) {
      this.$scope.selectedAssignees.push(id);
      this.$scope.countSelected++;
    } else {
      this.$scope.selectedAssignees = this.$scope.selectedAssignees.filter((selected) => selected !== id);
      this.$scope.countSelected--;
    }
  };

  private finish = (): void => {
    this.$scope.$close(this.$scope.selectedAssignees);
  };

  private close = (): void => {
    this.$scope.$close([]);
  };
}
